import { getActiveFilterStates } from 'tradera-apps/tradera/components/discover/helpers/filter-states';

const normalizeFilters = filters => {
    if (filters) {
        let normalized = {};
        filters.map(filter => {
            const { parameter } = filter;
            // eslint-disable-next-line better-mutation/no-mutation
            normalized = {
                ...normalized,
                [parameter]: {
                    ...filter
                }
            };
        });
        return normalized;
    }
};

const activeFilters = (filters, shippingRegionCountryCodeIso2) => {
    if (filters) {
        let normalized = [];
        filters.map(filter => {
            const { selectedValue } = filter;
            if (
                getActiveFilterStates(shippingRegionCountryCodeIso2).includes(
                    selectedValue
                )
            ) {
                normalized.push(filter);
            }
        });
        return normalized;
    }
};

const normalize = (responseData, shippingRegionCountryCodeIso2 = 'se') => {
    const normalized = {
        activeBrands: [],
        activeFilters: [],
        attributeFilters: [],
        categoryPath: responseData.categoryPath || [],
        currentCategoryId: responseData.categoryPath?.[0]?.id || 0,
        fallbackItemsById: [],
        filterCategories: {},
        filterPrice: {},
        filters: {},
        headerText: responseData.headerText || null,
        internalSearch: responseData.internalSearchBar || {},
        introText: responseData.introText || null,
        isSavedSearchEmailEnabled:
            responseData?.isSavedSearchEmailEnabled || false,
        isShopOwnedByCurrentMember:
            responseData?.itemsOnDisplay?.isShopOwnedByCurrentMember || false,
        itemsById: [],
        itemsOnDisplayById: [],
        mainText: responseData.mainText || null,
        pagination: responseData.pagination || null,
        fallbackUrl: responseData.fallbackUrl || null,
        totalItems: responseData.totalItems || 0,
        reduxContainer: responseData.reduxContainer || {},
        searchLanguages: responseData.searchLanguages || []
    };

    if (responseData.filters) {
        normalized.filterCategories = responseData.filters.categoryFilter;
        normalized.filters = normalizeFilters(
            responseData.filters.singleOptionFilters
        );
        normalized.activeFilters = activeFilters(
            responseData.filters.singleOptionFilters,
            shippingRegionCountryCodeIso2
        );
        normalized.filterPrice = responseData.filters.priceRangeFilter;
        normalized.attributeFilters = responseData.filters.attributeFilters;
    }

    if (responseData.items) {
        responseData.items.map(item => {
            normalized.itemsById.push(item.itemId);
        });
    }

    if (responseData.itemsOnDisplay) {
        responseData.itemsOnDisplay.items.map(item => {
            normalized.itemsOnDisplayById.push(item.itemId);
        });
    }

    if (responseData.fallbackItems) {
        responseData.fallbackItems.map(item => {
            normalized.fallbackItemsById.push(item.itemId);
        });
    }

    normalized.status = responseData.status;
    return normalized;
};

export { normalize };
